import {
  Base404Error,
  isEvent404Error,
  isOrg404Error,
} from '../../utils/errorResponses';
import { BaseError } from './BaseError';
import { Event404 } from './Error404/Event404';
import { Org404 } from './Error404/Org404';

export function Error403({ error }: { error: Base404Error }) {
  if (isOrg404Error(error)) {
    return <Org404 orgSlug={error.orgSlug} />;
  } else if (isEvent404Error(error)) {
    return <Event404 eventSlug={error.eventSlug} />;
  } else {
    return (
      <BaseError status="403" title="Not Allowed">
        <p>You are not allowed to access this page.</p>
      </BaseError>
    );
  }
}
